import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { List, ListItem, ListItemText } from '@material-ui/core';
import { Link as LinkScroll } from 'react-scroll';
import { connect } from 'react-redux';
import * as ROUTES from '../../routes/';

const useStyles = makeStyles({
  containerMenu: {
    position: 'sticky',
    top: 64,
  },
  linkItem: {
    color: 'inherit',
    textDecoration: 'none',
  },
  listItemButton: {
    color: '#484848',
    border: 'none',
    backgroundColor: 'transparent',
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  listItemSelected: {
    backgroundColor: 'transparent !important',
  },
  primaryListItemText: {
    fontWeight: 'normal',
    paddingLeft: 13,
  },
  primaryListItemTextSelected: {
    fontWeight: 'bold',
    borderLeft: '3px solid #106c9d',
    paddingLeft: 13,
  },
});


const SideNav = props => {
  const classes = useStyles(props);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [active, setActive] = useState(0);
  const [clicked, setClicked] = useState(false);
  const [scrolling, setScrolling] = useState(false);

  let timeoutId = null;

  useEffect(() => {
    const debouncedHandleScroll = function handleScroll() {
      setScrolling(true);
      clearTimeout(timeoutId);

      timeoutId = setTimeout(() => {
        setSelectedIndex(active);
      }, 500);
    };

    window.addEventListener('scroll', debouncedHandleScroll);

    return _ => {
      window.removeEventListener('scroll', debouncedHandleScroll);
    };
  }, [active]);

  const handleClick = (event, index) => {
    console.log('clicked num', index)
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      setActive(index)
      
      setClicked(false);
    }, 500);

    setClicked(true);
    /* 
    if(selectedIndex === index){
      setClicked(false);
    }else {
      setClicked(true);
    }*/
  };
  const { role, community, idLawFirm } = props;
  const navOptions = [
    {
      name: 'Apariencia',
      to: 'look',
      duration: 500,
    },
    idLawFirm
      ? {
          name: 'Titular del despacho',
          to: 'premiumMainHolder',
          duration: 500,
        }
      : null,
    role === 'lawFirm'
      ? {
          name: 'Sobre el despacho',
          to: 'about',
          duration: 500,
        }
      : null,
    role === 'lawFirm'
      ? {
          name: 'Áreas de práctica',
          to: 'specialty',
          duration: 500,
        }
      : null,
    {
      name: 'Experiencia',
      to: 'expertise',
      duration: 500,
    },
    role === 'lawyer'
      ? {
          name: 'Sobre ti',
          to: 'about',
          duration: 500,
        }
      : null,
    role === 'lawyer'
      ? {
          name: 'Áreas de práctica',
          to: 'specialty',
          duration: 500,
        }
      : null,
    role === 'lawyer'
      ? {
          name: 'Educación',
          to: 'education-lawyer',
          duration: 500,
        }
      : null,
    role === 'lawyer'
      ? {
          name: 'Cursos y diplomados',
          to: 'courses-lawyer',
          duration: 500,
        }
      : null,
    role === 'lawyer'
      ? {
          name: 'Certificaciones',
          to: 'certification',
          duration: 500,
        }
      : null,
    role === 'lawyer'
      ? {
          name: 'Premios',
          to: 'award',
          duration: 500,
        }
      : null,
    role === 'lawyer'
      ? {
          name: 'Publicaciones',
          to: 'publication',
          duration: 500,
        }
      : null,
    role === 'lawyer'
      ? {
          name: 'Experiencia laboral',
          to: 'laboral',
          duration: 500,
        }
      : null,
    {
      name:'Información',
      to: 'contact',
      duration: 500,
    }, 
    {
      name: 'Redes sociales',
      to: 'socialNetworks',
      duration: 500,
    },
    role === 'lawFirm'
      ? {
          name: 'Titular',
          to: 'addHolder',
          duration: 500,
        }
      : null,
    role === 'lawFirm'
      ? {
          name: 'Equipo',
          to: 'add',
          duration: 500,
        }
      : null,
    {
      name: role === 'lawFirm' ? 'Sedes' : 'Sede' ,
      to: 'site',
      duration: 500,
    },
    {
      name: 'Horarios',
      to: 'schedule',
      duration: 500,
    },
    {
      name: 'Costos',
      to: 'cost',
      duration: 500,
    },
    {
      name: 'Comunidad',
      to: 'communitySection',
      duration: 500,
    },
    community === true ?
    {
      name: 'Tiempo de respuesta',
      to: 'responseTime',
      duration: 500,
    } :
    null,
    {
      name: 'Fotografías',
      to: 'picture',
      duration: 500,
    },
    {
      name: 'Videos',
      to: 'videoProf',
      duration: 500,
    },
    {
      name: 'Compartir',
      to: 'share',
      duration: 500,
    },
  ];
  return (
    <div className={classes.containerMenu}>
      <List component="nav" className={classes.navList}>
        {navOptions.map((option, index) => {
          if (option === null) {
            return null;
          }
          return (
            <LinkScroll
              key={index}
              to={option.to}
              smooth="true"
              duration={500}
              //delay={100}
              offset={-65}
              isDynamic={true}
              spy={clicked ? false : true}
              onSetActive={() => {
                setActive(index);
                //setSelectedIndex(index);
              }}
            >
              <ListItem
                selected={active === index}
                onClick={event => handleClick(event, index)}
                classes={{
                  button: classes.listItemButton,
                  selected: classes.listItemSelected,
                }}
                style={{ height: 48 }}
                button
              >
                <ListItemText
                  primary={option.name}
                  classes={{
                    primary:
                      active === index
                        ? classes.primaryListItemTextSelected
                        : classes.primaryListItemText,
                  }}
                />
              </ListItem>
            </LinkScroll>
          );
        })}
      </List>
    </div>
  );
};

const mapStateToProps = state => ({
  role: state.authClient.role,
  community: state.authClient.community,
  idLawFirm: state.authClient.idLawFirm,
});
export default connect(mapStateToProps)(SideNav);
